import { render, staticRenderFns } from "./FormTopicScaffold.vue?vue&type=template&id=5bdde9cc&"
import script from "./FormTopicScaffold.vue?vue&type=script&lang=js&"
export * from "./FormTopicScaffold.vue?vue&type=script&lang=js&"
import style0 from "./FormTopicScaffold.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormTopicScaffold.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports